import { useState } from "react";
import { X } from "lucide-react";
import api from "../../services/api";

export default function CreateScheduleModal({ onClose, onSave }) {
  var nameState = useState("");
  var emailState = useState("");
  var typeState = useState("call");
  var dateState = useState("");
  var notesState = useState("");
  var loadingState = useState(false);
  var errorState = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!nameState[0].trim() || !dateState[0]) return;
    loadingState[1](true); errorState[1](null);
    try {
      await api.post("/schedule", {
        client_name: nameState[0].trim(),
        client_email: emailState[0].trim() || null,
        schedule_type: typeState[0],
        date: new Date(dateState[0]).toISOString(),
        notes: notesState[0].trim() || null,
      });
      onSave();
    } catch (err) {
      var d = err.response ? err.response.data : null;
      var detail = d ? d.detail : "Erro ao agendar";
      errorState[1](typeof detail === "string" ? detail : "Erro ao agendar");
    } finally { loadingState[1](false); }
  }

  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-50" onClick={onClose} />
      <div className="fixed bottom-0 left-0 right-0 sm:bottom-auto sm:top-1/2 sm:left-1/2 sm:-translate-x-1/2 sm:-translate-y-1/2 z-50 sm:max-w-md sm:w-full" data-testid="create-schedule-modal">
        <div className="bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl max-h-[85vh] overflow-y-auto">
          <div className="flex items-center justify-between p-5 border-b border-gray-100">
            <h2 className="text-lg font-bold text-[#0A2F3D]">Novo Agendamento</h2>
            <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg"><X className="w-5 h-5 text-gray-500" /></button>
          </div>
          {errorState[0] && <div className="mx-5 mt-3 px-4 py-2.5 rounded-lg text-sm bg-red-50 text-red-700 border border-red-200">{errorState[0]}</div>}
          <form onSubmit={handleSubmit} className="p-5 space-y-4">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1.5">Nome do Cliente *</label>
              <input type="text" value={nameState[0]} onChange={function(e){nameState[1](e.target.value);}}
                className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                placeholder="Nome do cliente" required data-testid="schedule-form-name" />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1.5">Email do Cliente</label>
              <input type="email" value={emailState[0]} onChange={function(e){emailState[1](e.target.value);}}
                className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                placeholder="email@exemplo.com" data-testid="schedule-form-email" />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Tipo</label>
                <select value={typeState[0]} onChange={function(e){typeState[1](e.target.value);}}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                  data-testid="schedule-form-type">
                  <option value="call">Ligacao</option>
                  <option value="presencial">Presencial</option>
                  <option value="video">Video-chamada</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Data/Hora *</label>
                <input type="datetime-local" value={dateState[0]} onChange={function(e){dateState[1](e.target.value);}}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                  required data-testid="schedule-form-date" />
              </div>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1.5">Observacao</label>
              <textarea value={notesState[0]} onChange={function(e){notesState[1](e.target.value);}}
                className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm resize-none focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                rows="2" data-testid="schedule-form-notes" />
            </div>
            <div className="flex gap-3 pt-1">
              <button type="button" onClick={onClose} className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
              <button type="submit" disabled={loadingState[0]} className="flex-1 px-4 py-2.5 bg-[#3B82F6] text-white rounded-xl text-sm font-medium hover:bg-[#2563EB] disabled:opacity-50" data-testid="schedule-form-submit">
                {loadingState[0] ? "Agendando..." : "Agendar"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
